import React, { Component } from "react";
import '../rnr.css';

class Home extends Component {
  render() {
    return (
      <main className="flex-shrink-0">
        <div className="container">
          <h4 className="mt-3">Mini-Meucci React App</h4>
          <p className="lead">Prototype that demonstrates several steps of Meucci's 10 step Advanced Risk and Portfolio Management framework.</p>
          <ul>
            <li>Frontend is a React App</li>
            <li>Backend uses AWS Serverless architecture e.g. API Gateway, Lambda functions</li>
          </ul>
        </div>
      </main>
    );
  }
}
 
export default Home;